import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import ScalarMetric from '../ScalarMetric';

export default function AveragePerUserMetric({ data }: { data: graphql.AnalyticsGoalsPerUser }) {
	const { t } = useTranslation();

	const average = data.average.toFixed(1);

	return (
		<ScalarMetric
			loading={false}
			title={t('dashboard.metrics.goalsAveragePerUser.title')}
			value={average}
			byline={t('dashboard.metrics.goalsAveragePerUser.byline', {
				goals: data.goals,
				users: data.users,
			})}
		/>
	);
}
